import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EBnibProductSortField,
  IBnibProduct,
  PBnibProductFilter,
} from "src/core/bnibProduct/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IBnibProductState {
  bnibProducts: IBnibProduct[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IBnibProductState = {
  bnibProducts: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "bnib-product/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "bnib-product/FETCH_SUCCEEDED";
const FETCH_FAILED = "bnib-product/FETCH_FAILED";
const POLLING_START_REQUESTED = "bnib-product/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "bnib-product/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IBnibProduct[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    userId: number;
    filter: PBnibProductFilter;
    pagination: IPagination;
    sorts: ISort<EBnibProductSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IBnibProductState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IBnibProductState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.bnibProducts = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
